import { useState } from 'react';

export default function CtaSection() {
  const [showDownload, setShowDownload] = useState(false);

  return (
    <section id="download" className="relative w-full py-24 md:py-32 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20dramatic%20composition%20with%20deep%20crimson%20and%20warm%20amber%20gradients%2C%20swirling%20atmospheric%20smoke%20texture%2C%20cinematic%20dark%20background%20with%20golden%20light%20burst%2C%20modern%20editorial%20style%2C%20bold%20dynamic%20mood%2C%20clean%20abstract%20art%2C%20no%20text%20no%20watermark&width=1800&height=800&seq=cta-download-bg&orientation=landscape"
          alt="下载51吃瓜App"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/80 via-black/50 to-black/40"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center justify-between gap-10">
          <div className="flex-1">
            <h2 className="font-heading font-black text-4xl md:text-5xl lg:text-6xl text-background-50 leading-tight">
              下载51吃瓜App
              <br />
              <span className="text-primary-400">吃瓜快人一步</span>
            </h2>
            <p className="mt-4 text-background-50/60 text-base md:text-lg leading-relaxed max-w-md">
              覆盖全网最热爆料，智能推送你的专属吃瓜内容。支持iOS与Android双平台，随时随地畅快吃瓜。
            </p>
          </div>

          <div className="flex-shrink-0">
            <button
              onClick={() => setShowDownload(true)}
              className="group inline-flex items-center gap-3 px-10 py-4 bg-background-50 text-primary-600 font-bold text-base rounded-full hover:bg-background-100 transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              立即下载
              <span className="w-8 h-8 flex items-center justify-center bg-primary-500 text-background-50 rounded-full transition-transform duration-300 group-hover:translate-x-1">
                <i className="ri-arrow-right-line"></i>
              </span>
            </button>
          </div>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-8 mt-16">
          {[
            { number: '500万+', label: '累计用户' },
            { number: '1.5万+', label: '爆料文章' },
            { number: '99.7%', label: '推送到达率' },
            { number: '4.9分', label: 'App Store评分' },
          ].map((stat) => (
            <div key={stat.label} className="text-center">
              <div className="font-heading font-black text-2xl md:text-3xl text-background-50">
                {stat.number}
              </div>
              <div className="mt-1 text-background-50/40 text-sm">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>

      {showDownload && (
        <div className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-black/60 backdrop-blur-sm">
          <div className="relative bg-background-50 rounded-2xl p-8 max-w-md w-full">
            <button
              onClick={() => setShowDownload(false)}
              className="absolute top-4 right-4 w-8 h-8 flex items-center justify-center rounded-full hover:bg-background-100 cursor-pointer transition-colors"
            >
              <i className="ri-close-line text-foreground-600 text-lg"></i>
            </button>
            <div className="text-center">
              <div className="w-16 h-16 mx-auto mb-4 flex items-center justify-center bg-primary-500 rounded-2xl">
                <i className="ri-fire-line text-background-50 text-2xl"></i>
              </div>
              <h3 className="font-heading font-bold text-xl text-foreground-900 mb-2">
                下载51吃瓜App
              </h3>
              <p className="text-foreground-600 text-sm mb-6">
                扫描二维码或在应用商店搜索「51吃瓜」下载
              </p>
              <div className="flex flex-col sm:flex-row gap-3 justify-center">
                <a
                  href="#"
                  className="flex-1 flex items-center justify-center gap-2 px-6 py-3 bg-foreground-900 text-background-50 rounded-full text-sm font-semibold hover:bg-foreground-800 transition-colors cursor-pointer whitespace-nowrap"
                >
                  <i className="ri-apple-line text-lg"></i>
                  iOS下载
                </a>
                <a
                  href="#"
                  className="flex-1 flex items-center justify-center gap-2 px-6 py-3 bg-primary-500 text-background-50 rounded-full text-sm font-semibold hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
                >
                  <i className="ri-android-line text-lg"></i>
                  Android下载
                </a>
              </div>
              <p className="mt-4 text-foreground-500 text-xs">
                最新版本 v4.2.1 · 支持iOS 14+ / Android 8+
              </p>
            </div>
          </div>
        </div>
      )}
    </section>
  );
}